module.exports = __webpack_public_path__ + "img/tr.3e0c8002.svg";